/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function getClipboard(options, context) {
    // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
    var formatOutput = function (ret) {
        var _a;
        var content = (_a = ret === null || ret === void 0 ? void 0 : ret.data) === null || _a === void 0 ? void 0 : _a.content;
        return {
            content: content,
        };
    };
    context === null || context === void 0 ? void 0 : context.WVCall('CNHybridPasteBoard.getStringFromPasteboard', options, {
        formatOutput: formatOutput,
    });
}

export { getClipboard as default };
